import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../../../Seller/Sidebar';
import ProfileMain from '../Profile/ProfileMain';
import PropertiesSearched from '../Profile/PropertiesSearched';

const ProfileSearchMain = () => {
  const [showSearched, setShowSearched] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#F9FAFB',
        flexDirection: { xs: 'column', md: 'row' },
        mt: { xs: '64px', md: '15px' },
      }}
    >
      {/* ✅ Hide Sidebar on mobile */}
      {!isMobile && <Sidebar />}

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          boxSizing: 'border-box',
          ml: { xs: 0, md: '25px' },
          mr: { xs: 0, md: '80px' },
          pt: { xs: '16px', md: '32px' },
          pb: { xs: '16px', md: '32px' },
        }}
      >
        <Box sx={{ mt: { xs: 0, md: '2px' } }}>
          <ProfileMain />
        </Box>
        {showSearched && <PropertiesSearched />}
      </Box>
    </Box>
  );
};

export default ProfileSearchMain;